import reportService from '../services/report.service';

const reports = {
    namespaced: true,
    state: {},
    actions: {
        patientList(_, params){return reportService.patientList(params.fromDate, params.toDate);},
        acceptedLog(_, params){return reportService.acceptedLog(params.fromDate, params.toDate);},
        incidentException(){return reportService.incidentException();},
        patientException(){return reportService.patientException();},
        accountException(){return reportService.accountException();},
        claimException(){return reportService.claimException();},
        newaccountregistrationsreport(_, params){return reportService.newaccountregistrationsreport(params.fromDate, params.toDate);},
        verifiedaccountsreport(_, params){return reportService.verifiedaccountsreport(params.fromDate, params.toDate);},
        queriedaccountsreport(_, params){return reportService.queriedaccountsreport(params.fromDate, params.toDate);},
        queriedaccountspdfreport(_, params){return reportService.queriedaccountspdfreport(params);},
        rejectedaccountspdfreport(_, params){return reportService.rejectedaccountspdfreport(params);},        
        paidaccountspdfreport(_, params){return reportService.paidaccountspdfreport(params);},
        acceptedaccountspdfreport(_, params){return reportService.acceptedaccountspdfreport(params);},
        partlyacceptedaccountspdfreport(_, params){return reportService.partlyacceptedaccountspdfreport(params);},
        newaccountspdfreport(_, params){return reportService.newaccountspdfreport(params);},
        acceptedaccountsreport(_, params){return reportService.acceptedaccountsreport(params.fromDate, params.toDate);},
        rejectedaccountsreport(_, params){return reportService.rejectedaccountsreport(params.fromDate, params.toDate);},
        processedaccountsreport(_, params){return reportService.processedaccountsreport(params.fromDate, params.toDate);},
        partlyacceptedaccountsreport(_, params){return reportService.partlyacceptedaccountsreport(params.fromDate, params.toDate);},
        arsuspendedincidentsreport(_, params){return reportService.arsuspendedincidentsreport(params.fromDate, params.toDate);},
        lateregistrationsuspendedincidentsreport(_, params){return reportService.lateregistrationsuspendedincidentsreport(params.fromDate, params.toDate);},
        missingdocumentssuspendedpatientsreport(_, params){return reportService.missingdocumentssuspendedpatientsreport(params.fromDate, params.toDate);},
        accountsstatusreport(_, params){return reportService.accountsstatusreport(params);}, 
        getpatientlog(_, params){return reportService.getpatientlog(params);}, 
        getincidentlog(_, params){return reportService.getincidentlog(params);},
        
        rejectedaccountsreportlive(_, params){return reportService.rejectedaccountsreportlive(params);},
        acceptedaccountsreportlive(_, params){return reportService.acceptedaccountsreportlive(params);},
        partlyacceptedaccountsreportlive(_, params){return reportService.partlyacceptedaccountsreportlive(params);},
        verifiedaccountsreportlive(_, params){return reportService.verifiedaccountsreportlive(params);},
        queriedaccountsreportlive(_, params){return reportService.queriedaccountsreportlive(params);},
        processedaccountsreportlive(_, params){return reportService.processedaccountsreportlive(params);},
        newaccountsreportlive(_, params){return reportService.newaccountsreportlive(params);},

        providerReport(_, params){return reportService.providerReport(params);},
        transactionLog(_, params){return reportService.transactionLog(params);},

        acceptednotyetsubmittedclaimsreportlive(_, params){return reportService.acceptednotyetsubmittedclaimsreportlive(params);},







    },
    getters: {},
    mutations: {},
};

export default reports;
